export const mutations = {
  addTicket(state, ticket) {
    state.ticket = ticket;
  },
  setTicket(state, ticket) {
    state.ticket = ticket;
  },
  addTickets(state, ticket) {
    state.tickets = ticket;
  },
  addTicketsPage(state, ticket) {
    state.tickets = ticket;
  },
};
